/********************************************************************
 * Project: WDCK（2021）
 * Class: InputDateDirective
 * ----------------------------------------
 * <summary>
 * Input Date Directive
 * </summary>
 * <history>
 *      AnBD     2021/15/09      Create
 * </history>
 ********************************************************************/
 import { Directive, ElementRef, HostListener } from '@angular/core';

 @Directive({
     selector: '[inputDate]',
 })
 export class InputDateDirective {
     // Backspace, tab, end, home
     private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-'];
     constructor(private el: ElementRef) {
     }
     @HostListener('paste', ['$event'])
     blockPaste(event) {
        event.preventDefault();
     }
     @HostListener('keydown', ['$event'])
     onKeyDown(event) {
         if (event.shiftKey) {
             event.preventDefault();
         }
         if (event.ctrlKey || event.metaKey) {
             return;
         }
         if (event.which < 48 || (event.which > 57 && event.which < 96) || event.which > 105) {
             if (event.which === 9 || event.which === 8 || event.which === 127 || event.which === 186 ||
                 event.which === 46 || event.which === 39 || event.which === 37) {
                 return;
             }
             return false;
         }
         // Allow Backspace, tab, end, and home keys
         if (this.specialKeys.indexOf(event.key) !== -1) {
             return;
         }
     }
     @HostListener('keyup', ['$event'])
     onKeyUp(event) {
         if (event.shiftKey) {
             event.preventDefault();
         }
         if (event.ctrlKey || event.metaKey) {
             return;
         }
         const key = event.keyCode;
         if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
             return;
         }
         if (this.el.nativeElement.value && this.el.nativeElement.value.length === 8) {
             return;
         }
         const position = event.target.selectionStart;
         if (key === 8) {
             this.el.nativeElement.setSelectionRange(position, position);
         }
         const current: string = this.el.nativeElement.value.replace(/[^0-9]/g, '');
         this.el.nativeElement.value = this.formatTime(current);
     }
     formatTime(time) {
         if (!time) {
             return '';
         }
         const value = time.toString().trim().replace(/^\+/, '');
         if (value.match(/[^0-9]/)) {
             return time;
         }
         let dates: any;
         let year: any;
         let month: any;
         let day: any;
         switch (value.length) {
             case 1:
                dates = value;
                return dates;
             case 2:
                dates = value;
                return dates;
             case 3:
                dates = value;
                return dates;
             case 4:
                 year = value.slice(0, 4);
                 return year + '/';
             case 5:
                year = value.slice(0, 4);
                month = value.slice(4);
                return (year + '/' + month).trim();
             case 6:
                year = value.slice(0, 4);
                month = value.slice(4, 6);
                return (year + '/' + month + '/').trim();
             case 7:
                year = value.slice(0, 4);
                month = value.slice(4, 6);
                day = value.slice(6);
                return (year + '/' + month + '/' + day).trim();
             case 8:
                year = value.slice(0, 4);
                month = value.slice(4, 6);
                day = value.slice(6, 8);
                return (year + '/' + month + '/' + day).trim();
         }
     }
}
